export default "__VITE_ASSET__B60JN6IW__"